// @ts-nocheck
import { createHandlerChainRunner, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidateEmail,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        isSubscribed?: boolean;
        billToId?: string;
        shipToId?: string;
        useDefaultCustomer?: boolean;
        email?: string;
        fulfillmentMethod?: string;
        defaultWarehouse?: WarehouseModel;
    },
    {
        emailErrorMessage?: string;
    }
>;

const storeEmailRegexp = new RegExp("^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$"); // Store Custom Code

export const StoreValidateEmail: HandlerType = props => {
    const {
        parameter: { email },
    } = props;
    if (typeof email === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Email Address"));
    const emailFieldMessage = siteMessage("Field_Invalid", translate("Email Address"));

    const errorMessage = email === "" ? requiredFieldMessage : storeEmailRegexp.test(email) ? "" : emailFieldMessage; // Store Custom Code
    props.emailErrorMessage = errorMessage as string;
};

replaceInChain(chain, ValidateEmail, StoreValidateEmail);
